import React from 'react'
import AmexImg from '../../../assets/icons/amex-icon.png'
import AmexImgPb from '../../../assets/icons/amex-icon-pb.png'
import { StyledIcon } from './styled-icon.style'

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const AmexIcon = ({ disabled, className }) => (
	<StyledIcon className={className}>
		<img src={disabled ? AmexImgPb : AmexImg} alt="Ícone Amex" />
	</StyledIcon>
)

export default AmexIcon
